import { createClassName } from 'utils/createClassName';

import './pressControlStyles.scss';

export const createPressControlClassName = createClassName('pressControl');
